import { render, staticRenderFns } from "./addDizhi.vue?vue&type=template&id=2ce718ab&scoped=true&"
import script from "./addDizhi.vue?vue&type=script&lang=js&"
export * from "./addDizhi.vue?vue&type=script&lang=js&"
import style0 from "./addDizhi.vue?vue&type=style&index=0&id=2ce718ab&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce718ab",
  null
  
)

export default component.exports